import { useMutation } from '@gogame/query';

import { useTemplates } from '../../TemplatesProvider';
import { exportTemplate } from '../../source/status-templates';
import { templatesQuery } from '../queryKeyFactory';

export const useExportTemplate = ({ name }) => {
  const { serverPageId } = useTemplates();

  const exportMutation = useMutation(
    templatesQuery.query(serverPageId).all(),
    (params) => exportTemplate({ pageId: serverPageId, name, ...params }),
    {
      mutateMessage: () => 'Download has started',
      successMessage: () => 'Download complete',
      errorMessage: (e) => e.message,
    }
  );

  return [exportMutation.mutateAsync, exportMutation];
};
